import React, { useState } from 'react'
import HideIcon from './icons/HideIcon';
import ShowIcon from './icons/ShowIcon';
import styled from 'styled-components';
import { Color, Colors } from '../styles/Colors';
import { FontScale } from '../styles/FontScale';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
    padding: ${({ $toc }) => ($toc ? '0 0 0 1rem' : '0')}; 
`;

const Button = styled.button`
    margin: 0 0 1rem 0; 
    padding: 0; 
    display: flex;
    flex-direction: row; 
    border: none;
    background: none; 

    & > span {
        font-size: ${FontScale.size_3}; 
        font-weight: 600; 
        color ${Color(Colors.black)}; 
        padding: 0 0 0 0.5rem; 
        &:hover {
            cursor: pointer; 
        }
    }
    
    & > svg {
        height: 32px; 
        width: 32px; 
        fill: ${Color(Colors.black)};
    }
`; 

const Wrapper = styled.div`
    opacity: ${({ $show }) => ($show ? 1 : 0)};
    display: grid; 
    grid-template-rows: ${({ $show }) => ($show ? '1fr' : '0fr')};
    transition: grid-template-rows 400ms ease, opacity 400ms ease;
    overflow: hidden;  
    padding-bottom: ${({$show}) => ($show ? '1.5rem' : '0')}; 
`;

const Inner = styled.div`
    // allow 0fr to actually collapse
    min-height: 0; 

    // Avoid “ghost” space from margins when collapsed
    > :first-child { 
        margin-top: 0; 
    }

    > :last-child  { 
        margin-bottom: 0; 
    }

`;

const ToggleSection = ({toc, title, children, moduleId}) => {
    const { t } = useTranslation(); 
    const [show, setShow] = useState(true);

    return (
        <Container $toc={toc} id={moduleId}>
            <Button $show={show} onClick={() => setShow(!show)}>
                {show === false ? (
                    <>
                        <ShowIcon />
                        <span>{`${t('common.showSection')} ${title}`}</span>
                    </>
                ) : (
                    <>
                        <HideIcon />
                        <span>{`${t('common.hideSection')} ${title}`}</span>
                    </>

                )}
            </Button>
            <Wrapper $show={show}>
                <Inner $show={show}>{children}</Inner>
            </Wrapper>
        </Container>
    )
}

export default ToggleSection